import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

import Home from "../../pages/home";
import Verify from "../../pages/verify";

import LoginComponent from "../../pages/login";
import DisableUser from "../../pages/disableUser";

import PublicRoute from "../../components/PublicRoute";
import StepperComponent from "../../components/stepper";
import PrivateRoute from "../../components/PrivateRoute";
import LayoutComponent from "../../components/layout/layout";
import VerifyLayoutComponent from "../../components/verifyLayout";

import { useAppSelector } from "../../store/store";
import IframeListener from "../../pages/IframeListener";
import LawyerIframeListener from "../../pages/LawyerIframeListener";

function UserRoutes() {
  const { authConfig } = useAppSelector((state: any) => state.authReducer);

  if (authConfig?.authData?.domain !== "" && authConfig?.authData?.clientId !== "") {
    return (
      <Auth0Provider
        domain={authConfig?.authData?.domain || ""}
        clientId={authConfig?.authData?.clientId || ""}
        useRefreshTokens={true}
        authorizationParams={{
          redirect_uri: window.location.origin,
          scope: "openid profile email read:current_user",
          audience: authConfig?.authData?.audience || "",
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginComponent />
                </PublicRoute>
              }
            ></Route>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <LoginComponent />
                </PublicRoute>
              }
            ></Route>
            <Route
              path="/verify"
              element={
                <VerifyLayoutComponent>
                  <Verify />
                </VerifyLayoutComponent>
              }
            ></Route>
            <Route path="/iframe-listener" element={<IframeListener />} />
            <Route path="/lawyer-iframe-listener" element={<LawyerIframeListener />} />
            <Route
              path="/home"
              element={
                <PrivateRoute>
                  <LayoutComponent>
                    <Home />
                  </LayoutComponent>
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/eligibility-check/:section-id"
              element={
                <PrivateRoute>
                  <LayoutComponent>
                    <StepperComponent />
                  </LayoutComponent>
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/eligibility-check/:index"
              element={
                <PrivateRoute>
                  <LayoutComponent>
                    <StepperComponent />
                  </LayoutComponent>
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/disable-user"
              element={
                <PrivateRoute>
                  <LayoutComponent>
                    <DisableUser />
                  </LayoutComponent>
                </PrivateRoute>
              }
            ></Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </Auth0Provider>
    );
  } else {
    return null;
  }
}

export default UserRoutes;
